<template>
<div v-show="false">
</div>
</template>

<script>
import OrderProvider from "@/modules/delivery/providers/OrderProvider";
import {mapGetters, mapMutations} from 'vuex'

export default {
  name: "SoundAlarm",
  data(){
    return {
      timeout: null,
      lastOrderNumber: null
    }
  },
  mounted() {
    this.fetchLastOrder()
  },
  destroyed() {
    clearTimeout(this.timeout)
  },
  computed:{
    ...mapGetters(['getLastOrderNumber'])
  },
  methods:{
    ...mapMutations(['setLastOrderNumber']),
    checkAlarm(newOrderNumber){
      if(this.getLastOrderNumber && newOrderNumber > this.getLastOrderNumber){
        let audio = new Audio(require('@/assets/mp3/pedido.mp3'))
        audio.play();
      }
    },
    fetchLastOrder(){
      OrderProvider.findLastOrderNumber()
      .then(r => {
        let newOrderNumber = r.data.findLastOrderNumber
        this.checkAlarm(newOrderNumber)
        this.setLastOrderNumber(newOrderNumber)
        this.timeout = setTimeout(this.fetchLastOrder,5000)
      })
    }
  }
}
</script>

<style scoped>

</style>
